import React from "react";

export const AnnouncementIcon = ({ color = "#7A89F4", opacity = 1 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <g opacity={opacity}>
        <path
          d="M14.6666 5.83425V8.50092M6.83325 4.16758H4.53325C3.41315 4.16758 2.85309 4.16758 2.42527 4.38557C2.04895 4.57732 1.74298 4.88328 1.55124 5.2596C1.33325 5.68743 1.33325 6.24748 1.33325 7.36759L1.33325 8.16758C1.33325 8.78884 1.33325 9.09947 1.43475 9.3445C1.57007 9.6712 1.82964 9.93076 2.15634 10.0661C2.40137 10.1676 2.712 10.1676 3.33325 10.1676V13.0009C3.33325 13.1557 3.33325 13.2331 3.33967 13.2983C3.40202 13.9313 3.90286 14.4321 4.5359 14.4945C4.60108 14.5009 4.67847 14.5009 4.83325 14.5009C4.98803 14.5009 5.06542 14.5009 5.13061 14.4945C5.76365 14.4321 6.26448 13.9313 6.32683 13.2983C6.33325 13.2331 6.33325 13.1557 6.33325 13.0009V10.1676H6.83325C8.01087 10.1676 9.45142 10.7988 10.5628 11.4047C11.2111 11.7581 11.5353 11.9348 11.7476 11.9088C11.9445 11.8847 12.0934 11.7963 12.2088 11.635C12.3333 11.461 12.3333 11.1129 12.3333 10.4167V3.91844C12.3333 3.22225 12.3333 2.87415 12.2088 2.70018C12.0934 2.53885 11.9445 2.45045 11.7476 2.42634C11.5353 2.40033 11.2111 2.57705 10.5628 2.93049C9.45141 3.53633 8.01087 4.16758 6.83325 4.16758Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
